import { Box, createTheme, ThemeProvider } from '@mui/material';
import './App.css';
import MainSidebar from './components/MainSidebar.js'

import PageRoutes from './routes/PageRoutes.js';
import PageSideRoute from './routes/PageSideRoute.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const theme = createTheme({

    palette: {
      success: {
        main: "#4BCE97",
        background: "#EDFAF5",
      },
      primary: {
        main: "#c62828",
        background: "#F7F8FA",
        border: "#C3C3C3"

      },

      secondary: {
        main: "#BCBCBC",
        // sidemenutext: "#BFBFBF",
        sidemenutext: "#000000",
        background: "#FFFFFF",
        textColor: "#C3C3C3"


      },

      error: {
        main: "#FF0000",
      },
      default: {
        main: "#445371",
        background: "#44537126",
      },
    },
    typography: {
      fontFamily: ["Kanit"].join(","),
      fontSize: 14,
      fontWeightBold: 500,
      h1: {
        fontFamily: "Kanit",
        fontWeight: 300,
        fontSize: "80px",
      },
      h2: {
        fontFamily: "Kanit",
        fontWeight: 300,
        fontSize: "48px",
      },
      h3: {
        fontFamily: "Kanit",
        fontWeight: 500,
        fontSize: "22px",
      },
      h4: {
        fontFamily: "Kanit",
        fontWeight: 400,
        fontSize: "20px",
        lineHeight: "23.12px",
        letterSpacing: "0.00735em",
      },
      h5: {
        fontFamily: "Kanit",
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "26.67px",
      },
      h6: {
        fontFamily: "Kanit",
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "25.6px",
      },
      tableheading: {
        fontFamily: "Kanit",
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "25.6px",
      },
      body1: {
        fontFamily: "Kanit",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: 1.5,
        letterSpacing: "0.00938em",
      },
      body2: {
        fontFamily: "Kanit",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "20px",
        letterSpacing: "0.01071em",
        color: "#000000",
      },

      button: {
        fontFamily: "Kanit",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "24.5px",
        letterSpacing: "0.02857em",
        textTransform: "none",
      },
      caption: {
        fontFamily: "Kanit",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "19.92px",
        letterSpacing: "0.03333em",
      },
      overline: {
        fontFamily: "Kanit",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "21.33px",
        letterSpacing: "0.08333em",
        textTransform: "uppercase",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            boxShadow: "none",
            textTransform: "none",
          },
          contained: {
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
          },
          outlined: {
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            borderRadius: "8px",
            "& .MuiOutlinedInput-root": {
              borderColor: "primary.border",
              "& fieldset": {
                borderColor: "primary.border",
              },
              "&:hover fieldset": {
                borderColor: "primary.border",
              },
              "&.Mui-focused fieldset": {
                borderColor: "primary.border",
              },
            },
            "& .MuiInputBase-input": {
              fontSize: "14px",
              fontFamily: "Kanit",
              color: "primary.main",
            },
          },
        },
      },
    },
  });

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light" // or 'dark'
        />
        <PageSideRoute />
      </ThemeProvider>
    </div>
  );
}

export default App;
